import { themeConfig } from 'config'

const defaultPhoto = themeConfig.title.uploadProductImage || ''
export const ProductSample = [
  {
    id: 1,
    group_id: 686,
    category_id: 698,
    sub_category_id: 702,
    manufacturer_id: 8,
    title: 'สินค้าตัวอย่าง1',
    details: 'Test',
    code: 'Test01',
    status: 'active',
    status_pos: 'active',
    request_status: 'approved',
    bom: 0,
    photos: [defaultPhoto],
    favorite: false,
    product_options: [
      {
        id: 11299,
        product_id: 9138,
        title: 'สินค้าตัวอย่าง',
        barcode: '',
        photo: defaultPhoto,
        publish: true,
        price: 99,
        offline_price: 0,
        price_a: 0,
        price_b: 0,
        price_c: 0,
        discount: 0,
        width: 0,
        height: 0,
        depth: 0,
        length: 0,
        weight: 2,
        area: 0,
        quantity: 99,
        quantity_offline: 0,
        OnlinePercentage: 0,
        bom: 0,
        reserve_qty: 0,
        created_at: '2021-09-20T15:41:23.419003+07:00',
        updated_at: '2022-07-18T13:42:14.12577+07:00',
        total: 0,
        total_discount: 0,
        total_amount: 0,
      },
    ],
    category: {
      id: 698,
      name: 'หมวดหมู่หลัก',
      slug: 'เคมีภัณฑ์',
      image: 'category/8a45e17e-8f29-4146-8393-812eb7546f76/iconbaandy172-7-01.png',
    },
    sub_category: {
      id: 702,
      name: 'หมวดหมู่ย่อย',
      slug: 'กาวซีเมนต์',
      image: 'category/18b1f55f-a666-41e5-be13-a6468b770c89/iconbaandy172-62-01.png',
    },
    manufacturer: {
      id: 8,
      slug: 'BUA',
      name: 'ปูนตราดอกบัว',
    },
    bigbang_promotion: {},
    group: {
      id: 686,
      name: 'กลุ่มสินค้า',
      slug: 'งานช่าง',
      image: 'category/983b3b14-d563-4efe-bce3-7ba908c37a10/Developer-BG.jpg',
    },
  },
  {
    id: 2,
    group_id: 686,
    category_id: 698,
    sub_category_id: 702,
    manufacturer_id: 8,
    title: 'สินค้าตัวอย่าง2',
    details: 'Test',
    code: 'Test02',
    status: 'inactive',
    status_pos: 'inactive',
    request_status: 'approved',
    bom: 1,
    photos: [defaultPhoto],
    favorite: false,
    product_options: [
      {
        id: 11299,
        product_id: 9138,
        title: 'สินค้าตัวอย่าง',
        barcode: '',
        photo: defaultPhoto,
        publish: true,
        price: 99,
        offline_price: 0,
        price_a: 0,
        price_b: 0,
        price_c: 0,
        discount: 0,
        width: 0,
        height: 0,
        depth: 0,
        length: 0,
        weight: 2,
        area: 0,
        quantity: 0,
        quantity_offline: 0,
        OnlinePercentage: 0,
        bom: 1,
        reserve_qty: 0,
        created_at: '2021-09-20T15:41:23.419003+07:00',
        updated_at: '2022-07-18T13:42:14.12577+07:00',
        total: 0,
        total_discount: 0,
        total_amount: 0,
      },
    ],
    category: {
      id: 698,
      name: 'หมวดหมู่หลัก',
      slug: 'เคมีภัณฑ์',
      image: 'category/8a45e17e-8f29-4146-8393-812eb7546f76/iconbaandy172-7-01.png',
    },
    sub_category: {
      id: 702,
      name: 'หมวดหมู่ย่อย',
      slug: 'กาวซีเมนต์',
      image: 'category/18b1f55f-a666-41e5-be13-a6468b770c89/iconbaandy172-62-01.png',
    },
    manufacturer: {
      id: 8,
      slug: 'BUA',
      name: 'ปูนตราดอกบัว',
    },
    bigbang_promotion: {},
    group: {
      id: 686,
      name: 'กลุ่มสินค้า',
      slug: 'งานช่าง',
      image: 'category/983b3b14-d563-4efe-bce3-7ba908c37a10/Developer-BG.jpg',
    },
  },
]

export const ProductOptionsSample = [
  {
    id: 1,
    product_id: 1,
    title: 'สินค้าตัวเลือก 1',
    barcode: '',
    photo: defaultPhoto,
    publish: true,
    price: 99,
    offline_price: 0,
    price_a: 0,
    price_b: 0,
    price_c: 0,
    discount: 0,
    width: 0,
    height: 0,
    depth: 0,
    length: 0,
    weight: 2,
    area: 0,
    quantity: 99,
    quantity_offline: 0,
    OnlinePercentage: 0,
    bom: 0,
    reserve_qty: 0,
    created_at: '2021-09-20T15:41:23.419003+07:00',
    updated_at: '2022-07-18T13:42:14.12577+07:00',
    total: 0,
    total_discount: 0,
    total_amount: 0,
  },
  {
    id: 1,
    product_id: 1,
    title: 'สินค้าตัวเลือก 2',
    barcode: '',
    photo: defaultPhoto,
    publish: true,
    price: 99,
    offline_price: 0,
    price_a: 0,
    price_b: 0,
    price_c: 0,
    discount: 0,
    width: 0,
    height: 0,
    depth: 0,
    length: 0,
    weight: 2,
    area: 0,
    quantity: 99,
    quantity_offline: 0,
    OnlinePercentage: 0,
    bom: 0,
    reserve_qty: 0,
    created_at: '2021-09-20T15:41:23.419003+07:00',
    updated_at: '2022-07-18T13:42:14.12577+07:00',
    total: 0,
    total_discount: 0,
    total_amount: 0,
  },
]

export const PurchaseListSampleData = [
  {
    row_count: 61,
    purchasing_id: 1,
    purchasing_no: 'PO20230613-0351-0001',
    supplier_name: 'Test Co.,ltd',
    total_quantity: 1,
    total_price: 1.3,
    purchasing_date: '2023-06-13T10:04:27.598+07:00',
    status: 'draft',
    created_at: '2023-06-13T10:10:11.210837+07:00',
  },
  {
    row_count: 61,
    purchasing_id: 2,
    purchasing_no: 'PO20230613-0351-0002',
    supplier_name: 'Test Co.,ltd',
    total_quantity: 1,
    total_price: 1.3,
    purchasing_date: '2023-06-13T10:04:27.598+07:00',
    status: 'pending',
    created_at: '2023-06-13T10:10:11.210837+07:00',
  },
  {
    row_count: 61,
    purchasing_id: 3,
    purchasing_no: 'PO20230613-0351-0003',
    supplier_name: 'Test Co.,ltd',
    total_quantity: 1,
    total_price: 1.3,
    purchasing_date: '2023-06-13T10:04:27.598+07:00',
    status: 'partial_receipt',
    created_at: '2023-06-13T10:10:11.210837+07:00',
  },
  {
    row_count: 61,
    purchasing_id: 4,
    purchasing_no: 'PO20230613-0351-0004',
    supplier_name: 'Test Co.,ltd',
    total_quantity: 1,
    total_price: 1.3,
    purchasing_date: '2023-06-13T10:04:27.598+07:00',
    status: 'success',
    created_at: '2023-06-13T10:10:11.210837+07:00',
  },
  {
    row_count: 61,
    purchasing_id: 5,
    purchasing_no: 'PO20230613-0351-0005',
    supplier_name: 'Test Co.,ltd',
    total_quantity: 1,
    total_price: 1.3,
    purchasing_date: '2023-06-13T10:04:27.598+07:00',
    status: 'condition_receipt',
    created_at: '2023-06-13T10:10:11.210837+07:00',
  },
  {
    row_count: 61,
    purchasing_id: 6,
    purchasing_no: 'PO20230613-0351-0006',
    supplier_name: 'Test Co.,ltd',
    total_quantity: 1,
    total_price: 1.3,
    purchasing_date: '2023-06-13T10:04:27.598+07:00',
    status: 'cancel',
    created_at: '2023-06-13T10:10:11.210837+07:00',
  },
]
